// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-edit-notes-modal',
    templateUrl: './edit-notes-modal.component.html',
    styleUrls: ['./edit-notes-modal.component.scss'],
})
export class EditNotesModalComponent implements OnInit, OnDestroy {
    public title = 'Edit Notes';
    public label = 'Notes';

    public isComponentAlive = true;

    public form: FormGroup = new FormGroup({
        notes: new FormControl('', [Validators.maxLength(1000)]),
    });

    constructor(
        private dialogRef: MatDialogRef<EditNotesModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {}

    ngOnInit() {
        if (this.data?.title) {
            this.title = this.data.title;
        }

        if (this.data?.label) {
            this.label = this.data.label;
        }

        if (this.data?.value) {
            this.form.setValue(this.data.value);
        }
    }

    public submit() {
        this.form.markAllAsTouched();
        if (this.form.valid) {
            this.dialogRef.close({
                update: true,
                notes: this.form.controls.notes.value,
            });
        }
    }

    public close() {
        this.dialogRef.close();
    }

    ngOnDestroy(): void {
        this.form.patchValue({ notes: '' });
        this.isComponentAlive = false;
    }
}
